import { Component, EventEmitter, Input, Output } from '@angular/core';

export enum ButtonKind {
  primaryLoud = 'primaryLoud',
  primary = 'primary',
  secondaryLoud = 'secondaryLoud',
  secondary = 'secondary',
  silent = 'silent'
}

export interface ButtonOptions {
  kind?: ButtonKind | string;
  type?: string;
  icon?: string;
  ariaLabel?: string;
  isDisabled?: boolean;
}

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.less']
})
export class ButtonComponent {
  @Input() isfocused= false;
  @Input() label: string;
  @Input() type = 'button';
  @Input() isDisabled = false;
  @Input() icon: string;
  @Input() kind: ButtonKind | string;
  @Input() ariaLabel: string;
  @Output() clicked: EventEmitter<any> = new EventEmitter();

  click(event: MouseEvent): void {
    event.stopPropagation();
    if (!this.isDisabled) {
      this.clicked.emit();
    }
  }
}

